import { errorHandler, PcsApiService } from '../pcs-api';
import { Roles } from './roles';
export class PermissionsService {
    constructor() {
        this.getUserRoles = async () => errorHandler(async () => {
            const { data: { data: rolesData } } = await this.pcsApi.get('user/roles');
            return rolesData.map(this.rolesPrepareView);
        });
        this.isAuthorized = (requiredRoles, userRoles, disableAdminOverride) => {
            if (!requiredRoles)
                return true;
            if (!userRoles)
                return false;
            if (userRoles.includes(Roles.Admin) && !disableAdminOverride)
                return true;
            if (typeof requiredRoles === 'string') {
                return userRoles.includes(requiredRoles);
            }
            const checkRole = (role, operator = 'or') => {
                if (typeof role === 'string') {
                    return userRoles.includes(role);
                }
                if (Array.isArray(role)) {
                    return role.reduce((acc, curr) => {
                        return operator === 'or'
                            ? checkRole(curr) || acc
                            : checkRole(curr) && acc;
                    }, operator !== 'or');
                }
                if (typeof role === 'object') {
                    return Object.keys(role).reduce((acc, oper) => {
                        const check = checkRole(role[oper], oper);
                        return operator === 'or' ? check || acc : check && acc;
                    }, operator !== 'or');
                }
                return false;
            };
            return checkRole(requiredRoles);
        };
        this.getRolesList = async () => errorHandler(async () => {
            const { data: { data: roles } } = await this.pcsApiV2.get('roles');
            return this.rolesDataMapper(roles);
        });
        this.rolesDataMapper = (roles) => {
            return roles.map((role) => ({
                name: role.attributes.name,
                value: role.attributes.id
            }));
        };
        this.rolesPrepareView = (data) => data.attributes.name;
        this.pcsApi = new PcsApiService();
        this.pcsApiV2 = new PcsApiService({ apiVersion: 'v2' });
    }
}
export default PermissionsService;
//# sourceMappingURL=permissions.service.js.map